import { ColorProps } from 'types';

// ==============================|| THEME 6 COLORS ||============================== //

const theme6: ColorProps = {
  // paper & background
  paper: '#ffffff',

  // primary
  primaryLight: '#e8eaf6',
  primary200: '#9fa8da',
  primaryMain: '#3f51b5',
  primaryDark: '#3949ab',
  primary800: '#283593',

  // secondary
  secondaryLight: '#e8eaf6',
  secondary200: '#9fa8da',
  secondaryMain: '#3f51b5',
  secondaryDark: '#3949ab',
  secondary800: '#283593',

  // success
  successLight: '#b9f6ca',
  success200: '#69f0ae',
  successMain: '#00e676',
  successDark: '#00c853',

  // error
  errorLight: '#ef9a9a',
  errorMain: '#f44336',
  errorDark: '#c62828',

  // orange
  orangeLight: '#fbe9e7',
  orangeMain: '#ffab91',
  orangeDark: '#d84315',

  // warning
  warningLight: '#fff8e1',
  warningMain: '#ffe57f',
  warningDark: '#ffc107',

  // grey
  grey50: '#f8fafc',
  grey100: '#eef2f6',
  grey200: '#e3e8ef',
  grey300: '#cdd5df',
  grey500: '#697586',
  grey600: '#4b5565',
  grey700: '#364152',
  grey900: '#121926',

  // ==============================|| DARK THEME VARIANTS ||============================== //

  // paper & background
  darkPaper: '#111936',
  darkBackground: '#1a223f',

  // dark 800 & 900
  darkLevel1: '#29314f',
  darkLevel2: '#212946',

  // text variants
  darkTextTitle: '#d7dcec',
  darkTextPrimary: '#bdc8f0',
  darkTextSecondary: '#8492c4',

  // primary dark
  darkPrimaryLight: '#eeedfd',
  darkPrimaryMain: '#7267ef',
  darkPrimaryDark: '#6a5fed',
  darkPrimary200: '#b9b3f7',
  darkPrimary800: '#554ae8',

  // secondary dark
  darkSecondaryLight: '#eeedfd',
  darkSecondaryMain: '#7267ef',
  darkSecondaryDark: '#6a5fed',
  darkSecondary200: '#b9b3f7',
  darkSecondary800: '#554ae8'
};

export default theme6;
